<script>
  import moment from "moment";
  import regioni from "./lib/regioni";
  import StampaButton from "./lib/StampaButton.svelte";
  import StampaModal from "./lib/StampaModal.svelte";
  import {
    ral,
    startDate,
    endDate,
    numeroMensilita,
    aliquotaIVS,
    aliquotaInail,
    aliquotaIVSDipendente,
    irpefNetta,
    irpefRegionale,
    irpefComunale,
    altreDetrazioniEventuali,
    importoIVSDatore,
    importoInail,
    rateoTfrAnnuale,
    esonero080,
    importoIVSDipendente,
    imponibileIRPEF,
    irpefLorda,
    importoIrpefComunale,
    contibutiAnno,
    imposteAnnuali,
    nettoDipendente,
    costoAnnuale,
    rateoTfrMensile,
    contibutMese,
    imposteMensili,
    nettoDipendenteMensile,
    costoMensile,
    coniugi,
    figliSopra,
    aliquotaIntegrazione,
    importoIntegrazione,
    aliquotaIntegrazioneLavoratore,
    importoIntegrazioneLavoratore,
    aliquotaNaspi,
    importoNaspi,
    contributoMalattia,
    aliquotaContrMalattia,
    aliquotaContrMaternita,
    importoContrMaternita,
    aliquotaCUAF,
    importoCUAF,
    aliquotaFondoGaranziaTfr,
    importoFondoGaranziaTfr,
    isCococo,
    isTempoIndeterminato,
    numeroGiorni,
    detrazioniPerRedditiLavoro,
    detrazioniConiugi,
    detrazioniFigliSopra21,
    altriFamiliari,
    detrazioniAltriFamiliari,
    trattamentoIntegrativo,
    importoInailCollaboratore,
    importoEsonero080,
    importoFormazione,
    aliquotaFormazione,
    aliquotaIvsParasub,
    importoIvsParasubCommittente,
    importoIvsParasubLavoratore,
    aliquotaMalattiaMaternitaAnfParasub,
    importoMalattiaMaternitaAnfParasubComm,
    importoMalattiaMaternitaAnfParasubLav,
    importoDisCollParasubComm,
    importoDisCollParasubLav,
    aliquotaDisCollParasub,
    aliquotaInailParasub,
    importoInailParasubComm,
    importoInailParasubLav,
    totaleAliquotaInps,
    totaleInps,
    totaleAliquotaInpsParasub,
    totaleInpsParasubComm,
    totaleInpsParasubLav,
    totaleInpsParasub,
    totaleInpsLavoratoreDip,
    sommac4l206,
    ulterioreDetrazioneC6
  } from "./store";
  // DEFAULT
  import { money } from "./lib/utilities";

  let showStampaModal = false;


  // cosi potrei prendermi i dati passati come props al primo component
  // FIXME: da fare dentro onMount probabilmente
  // import './app.css';

  let showDipendente = true;
  let showAgevolazione = true;
  let showQualifica = true;

  let showParametriContributivi = false;
  function toggleParametriContributivi() {
    showParametriContributivi = !showParametriContributivi;
  }

  let showParametriFiscali = false;
  function toggleParametriFiscali() {
    showParametriFiscali = !showParametriFiscali;
  }

  let tipologiaRapporto = [
    { id: 1, text: `Tempo Indeterminato` },
    { id: 2, text: `Tempo Determinato` },
  ];
  let tipologiaRapportoSelected = tipologiaRapporto[0];

  let tipoContratto = [
    { id: 1, text: `Dipendente`, funzione: () => {} },
    { id: 2, text: `COCOCO`, funzione: () => {} },
  ];
  let tipoContrattoSelected = tipoContratto[0];

  let tipologiaQualifica = [
    { id: 0, text: "" },
    { id: 1, text: `QUALIFICATO` },
    { id: 2, text: `APPRENDISTA +9` },
    { id: 3, text: `APPRENDISTA -9` },
  ];
  let tipologiaQualificaSelected = tipologiaQualifica[1];

  let tipoAgevolazione = [
    { id: 0, text: "" },
    {
      id: 1,
      text: `NESSUNA`,
      tipo: "nessuna",
    },
    {
      id: 2,
      text: `50% INPS carico ditta generico`,
      tipo: "50",
    },
    {
      id: 3,
      text: `100% INPS carico ditta generico`,
      tipo: "100",
    },
  ];
  let tipoAgevolazioneSelected = tipoAgevolazione[0];

  let regioneSelected = regioni[0];

  $: detrazioneLavoroDipendente = 0;

  // @ts-ignore
  $: difference = Math.floor(($startDate - $endDate) / 86400000) * -1;

  $: startDateString = moment($startDate).format("YYYY-MM-DD");
  $: endDateString = moment($endDate).format("YYYY-MM-DD");

  // $: calcolaNettoDipendente(ral, contibutiAnno, imposteAnnuali);
  // al cambio della regione calcolo aliquota irpef
  $: calcoloAliquotaRegionale(regioneSelected, $imponibileIRPEF);
  function calcoloAliquotaRegionale(regioneSelected, imponibileIRPEF) {
    $irpefRegionale = regioneSelected.calcolo(imponibileIRPEF);
  }

  // TODO: va Perfezionato e' un po brutale dice Gabriele
  $: cambioTipoContratto(tipoContrattoSelected);
  function cambioTipoContratto(tipoContrattoSelected) {
    if (tipoContrattoSelected.text === "COCOCO") {
      // azzero aliquote dipendente
      $aliquotaIVS = 0;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 0;
      $aliquotaContrMalattia = 0;
      $aliquotaContrMaternita = 0;
      $aliquotaCUAF = 0;
      $aliquotaFondoGaranziaTfr = 0;
      $aliquotaIVSDipendente = 0;
      $aliquotaFormazione = 0;
      $aliquotaInail = 0;
      $esonero080 = 0;

      $aliquotaIvsParasub = 33;
      $aliquotaMalattiaMaternitaAnfParasub = 0.72;
      $aliquotaDisCollParasub = 1.31;
      $aliquotaInailParasub = 0.4;

      $isCococo = true;
      showDipendente = false;
      showAgevolazione = false;
      showQualifica = false;
      tipoAgevolazioneSelected = tipoAgevolazione[0];
      tipologiaQualificaSelected = tipologiaQualifica[0];
    } else {
      // ripristino aliquote dipendente
      $aliquotaIVS = 23.81;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 1.31;
      $aliquotaContrMalattia = 2.44;
      $aliquotaContrMaternita = 0.24;
      $aliquotaCUAF = 0.68;
      $aliquotaFondoGaranziaTfr = 0.2;
      $aliquotaIVSDipendente = 9.19;
      $aliquotaFormazione = 0.3;
      $aliquotaInail = 0.4;
      $esonero080 = 0;

      // azzero aliquote di cococo
      $aliquotaIvsParasub = 0;
      $aliquotaMalattiaMaternitaAnfParasub = 0;
      $aliquotaDisCollParasub = 0;
      $aliquotaInailParasub = 0;

      tipoAgevolazioneSelected = tipoAgevolazione[1];
      tipologiaQualificaSelected = tipologiaQualifica[1];

      $isCococo = false;
      showDipendente = true;
      showAgevolazione = true;
      showQualifica = true;
    }
    // quando cambio rapporto rimuovo sempre le agevolazioni
    tipoAgevolazioneSelected = tipoAgevolazione[0];
  }

  $: cambiaTipoQualifica(tipologiaQualificaSelected);
  function cambiaTipoQualifica(tipo) {
    if (tipo.text == "QUALIFICATO") {
      $aliquotaIVS = 23.81;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 1.31;
      $aliquotaContrMalattia = 2.44;
      $aliquotaContrMaternita = 0.24;
      $aliquotaCUAF = 0.68;
      $aliquotaFondoGaranziaTfr = 0.2;
      $aliquotaIVSDipendente = 9.19;
      $aliquotaInail = 0.4;
    } else if (tipo.text == "APPRENDISTA +9") {
      $aliquotaIVS = 9.01;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 1.31;
      $aliquotaContrMalattia = 0.53;
      $aliquotaContrMaternita = 0.05;
      $aliquotaCUAF = 0.11;
      $aliquotaFondoGaranziaTfr = 0;
      $aliquotaIVSDipendente = 5.84;
      $aliquotaInail = 0.3;
    } else if (tipo.text == "APPRENDISTA -9") {
      $aliquotaIVS = 0;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 1.31;
      $aliquotaContrMalattia = 0;
      $aliquotaContrMaternita = 0;
      $aliquotaCUAF = 0;
      $aliquotaFondoGaranziaTfr = 0;
      $aliquotaIVSDipendente = 5.84;
      $aliquotaInail = 0;
    } else {
      $aliquotaIVS = 0;
      $aliquotaIntegrazioneLavoratore = 0;
      $aliquotaIntegrazione = 0;
      $aliquotaNaspi = 0;
      $aliquotaContrMalattia = 0;
      $aliquotaContrMaternita = 0;
      $aliquotaCUAF = 0;
      $aliquotaFondoGaranziaTfr = 0;
      $aliquotaIVSDipendente = 0;
      $aliquotaInail = 0;
    }
  }

  $: cambiaAgevolazione(tipoAgevolazioneSelected);
  function cambiaAgevolazione(tipoAgevolazioneSelected) {
    switch (tipoAgevolazioneSelected.tipo) {
      case "nessuna":
        $aliquotaIVS = 23.81;
        break;
      case "50":
        $aliquotaIVS = parseFloat((23.81 / 2).toFixed(2));
        break;
      case "100":
        $aliquotaIVS = 0;
        break;
    }
  }

  function cambiaTipologiaRapporto(e) {
    // $isTempoIndeterminato =
    $isTempoIndeterminato =
      tipologiaRapportoSelected.text == "Tempo Indeterminato";
  }

  function onChangeStartDate(e) {
    let date = e.currentTarget.value;
    $startDate = moment(date);
  }

  function onChangeEndDate(e) {
    let date = e.currentTarget.value;
    $endDate = moment(date);
  }
</script>

<main class="container mx-auto mt-2 mb-10">
  <div class="flex flex-grow justify-between items-center">
    <div class="grid grid-cols-1 gap-4 custom-grid">
      <div class="overflow-hidden whitespace-nowrap">
        <div class="bg-white shadow-lg rounded-lg border border-gray-200">
          <div class="bg-indigo-50 px-4 py-4 text-indigo-800 text-md rounded-t-md uppercase font-semibold border-b whitespace-normal">Simulazione costo del lavoro</div>
          <div class="p-4">
            <div class="mb-4">
              <label for="inizioLovaro" class="block text-sm font-medium">INIZIO LAVORO:</label>
              <input
                type="date"
                class="mt-1 block w-full text-sm border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                name="inizioLovaro"
                id="inizioLovaro"
                value={startDateString}
                on:change={onChangeStartDate}
              />
            </div>
            <div class="mb-4">
              <label for="termineLovaro" class="block text-sm font-medium">TERMINE LAVORO:</label>
              <input
                type="date"
                class="mt-1 block w-full text-sm border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                name="termineLovaro"
                id="termineLovaro"
                value={endDateString}
                on:change={onChangeEndDate}
              />
            </div>
            <div>
              <label for="ral" class="block text-sm font-medium whitespace-normal">Retribuzione Annuale Lorda (RAL):</label>
              <div class="flex mt-1 mb-4 text-sm w-full rounded-md overflow-x-auto border border-gray-200">
                <span class="px-1 flex items-center bg-gray-100 border-r border-gray-300">€</span>
                
                <input
                  type="number"
                  id="ral"
                  name="ral"
                  bind:value={$ral}
                  class="w-full px-1 py-2 text-sm border-none focus:outline-none min-w-0"
                />
                <span class="px-0.5 flex items-center bg-gray-100 border-l border-gray-300">.00</span>
              </div>
            </div>

            <hr class="my-3" />
            <div class="mb-2 text-sm font-medium">GIORNI: <strong>{$numeroGiorni}</strong></div>
            <hr class="my-3" />
            <div class="mb-2 w-full overflow-x-auto whitespace-normal text-sm font-medium">
              IMPONIBILE IRPEF: <strong id="imponibileIrpef">{money.format($imponibileIRPEF)}</strong>
            </div>
            <hr class="my-3" />

            <div class="mb-4">
              <label for="indicareSet1Set2" class="block text-sm font-medium text-gray-700">Indicare durata rapporto:</label>
              <select
                class="mt-1 block w-full text-sm border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                id="indicareSet1Set2"
                name="indicareSet1Set2"
                bind:value={tipologiaRapportoSelected}
                on:change={cambiaTipologiaRapporto}
              >
                {#each tipologiaRapporto as question}
                  <option value={question}>{question.text}</option>
                {/each}
              </select>
            </div>
            <div class="flex justify-center mt-4">
              <button 
                class="flex items-center gap-2 bg-indigo-700 text-white text-md font-semibold px-4 py-2 justify-center rounded shadow hover:bg-indigo-800 transition"
                on:click={() => showStampaModal = true}
              >
                <StampaButton />
                <span>STAMPA</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="rounded-md">
        <div class="grid grid-cols-1">
          <div class="col-span-1">
            <div class="card shadow-lg bg-white rounded-md border border-gray-200">
              <div class="text-indigo-800 text-md bg-indigo-50 uppercase p-4 border-b border-gray-300 font-semibold">
                Indicare parametri per la simulazione di costo
              </div>
              <div class="rounded-lg p-4 bg-white">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div class="flex flex-col justify-end h-full">
                    <label for="numMensilita" class="block text-sm font-medium mb-1">
                      Numero Mensilità:
                    </label>
                    <input
                      type="number"
                      id="numMensilita"
                      name="numMensilita"
                      min="0"
                      max="16"
                      bind:value={$numeroMensilita}
                      class="w-full rounded border border-gray-300 px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
          
                  <div class="flex flex-col justify-end h-full">
                    <label for="indicareSet1Set2" class="block text-sm font-medium mb-1">
                      Tipologia Rapporto:
                    </label>
                    <select
                      id="indicareSet1Set2"
                      name="indicareSet1Set2"
                      bind:value={tipoContrattoSelected}
                      class="w-full rounded border border-gray-300 px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      {#each tipoContratto as question}
                        <option value={question}>{question.text}</option>
                      {/each}
                    </select>
                  </div>
                
                  {#if showQualifica}
                    <div class="flex flex-col justify-end h-full">
                      <label for="qualifica" class="block text-sm font-medium mb-1">Qualifica:</label>
                      <select
                        id="qualifica"
                        name="qualifica"
                        bind:value={tipologiaQualificaSelected}
                        class="w-full rounded border border-gray-300 px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      >
                        {#each tipologiaQualifica as question}
                          <option value={question}>{question.text}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}

                  {#if showAgevolazione}
                    <div class="flex flex-col justify-end h-full" title="AGEVOLAZIONI CONTRIBUTIVE">
                      <label for="agevolazioniContributive" class="block text-sm font-medium mb-1">Agevolazione contributiva:</label>
                      <select
                        id="agevolazioniContributive"
                        name="agevolazioniContributive"
                        bind:value={tipoAgevolazioneSelected}
                        class="w-full rounded border border-gray-300 px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      >
                        {#each tipoAgevolazione as question}
                          <option value={question}>{question.text}</option>
                        {/each}
                      </select>
                    </div>
                  {/if}

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="rateoTfr" class="block mb-1 text-sm font-medium">Rateo TFR Annuale:</label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="rateoTfr"
                        name="rateoTfr"
                        disabled
                        bind:value={$rateoTfrAnnuale}
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 border-none text-gray-500 border-none focus:outline-none focus:ring-0"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="altreDetrazioni" class="block mb-1 text-sm font-medium">Eventuali Altre Detrazioni:</label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-white h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        min="0"
                        id="altreDetrazioni"
                        name="altreDetrazioni"
                        bind:value={$altreDetrazioniEventuali}
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm text-sm border-none rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                      />
                    </div>
                  </div>
                  <!-- TODO: Da aggiornare -->
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          <!-- FAMILIARI A CARICO -->
          <div class="col-span-2 md:col-span-2">
            <div class="bg-white shadow-lg rounded-lg border border-gray-200 h-full">
              <div class="bg-indigo-50 uppercase font-ms text-indigo-800 px-4 py-4 font-semibold border-b rounded-t-md">
                Familiari a carico
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full text-sm text-left">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="p-2"></th>
                      <th class="p-2 font-semibold">Num</th>
                      <th class="p-2 font-semibold">MESI</th>
                      <th class="p-2 font-semibold">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-t">
                      <th class="p-2 text-sm font-medium">Coniuge</th>
                      <td class="p-2"><input type="number" max="1" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$coniugi.numero} /></td>
                      <td class="p-2"><input type="number" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$coniugi.mesi} /></td>
                      <td></td>
                    </tr>
                    <tr class="border-t">
                      <th class="p-2 text-sm font-medium">Figli sopra i 21 anni</th>
                      <td class="p-2"><input type="number" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$figliSopra.numero} /></td>
                      <td class="p-2"><input type="number" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$figliSopra.mesi} /></td>
                      <td class="p-2"><input type="number" max="100" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$figliSopra.perc} /></td>
                    </tr>
                    <tr class="border-t">
                      <th class="p-2 text-sm font-medium">Altri Familiari</th>
                      <td class="p-2"><input type="number" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$altriFamiliari.numero} /></td>
                      <td class="p-2"><input type="number" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$altriFamiliari.mesi} /></td>
                      <td class="p-2"><input type="number" max="100" class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" bind:value={$altriFamiliari.perc} /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ALIQUOTA REGIONALE -->
          <div class="col-span-1 md:col-span-1">
            <div class="bg-white shadow-lg rounded-lg border border-gray-200 h-full">
              <div class="bg-indigo-50 uppercase font-ms text-indigo-800 px-4 py-4 font-semibold border-b rounded-t-md">
                Aliquote Regionali
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full text-sm text-left">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="p-2 font-semibold">Seleziona Regione</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-t">
                      <td class="p-4">
                        <select
                          id="indicareSet1Set2"
                          name="indicareSet1Set2"
                          bind:value={regioneSelected}
                          class="text-sm border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                        >
                          {#each regioni as question}
                            <option value={question}>{question.nome}</option>
                          {/each}
                        </select>
                        {#if regioneSelected && regioneSelected.aliquota}
                          <p class="text-xs pt-1">{@html regioneSelected.aliquota}</p>
                        {:else}
                          <p></p>
                        {/if}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ALIQUOTA ADDIZIONALE IRPEF COMUNALE -->
          <div class="col-span-1 md:col-span-1">
            <div class="bg-white shadow-lg rounded-lg border border-gray-200 h-full">
              <div class="bg-indigo-50 uppercase font-ms text-indigo-800 px-4 py-4 font-semibold border-b rounded-t-md">
                Aliquota addizionale IRPEF Comunale
              </div>
              <div class="p-4">
                <label for="tassoInail" class="block text-sm font-medium mb-2">Aliquota (%)</label>
                <div class="flex items-stretch h-10 border border-gray-200 rounded text-sm w-full max-w-full">
                  <input
                    type="number"
                    id="tassoInail"
                    min="0"
                    name="tassoInail"
                    bind:value={$irpefComunale}
                    class="w-full h-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                  <span
                    class="bg-gray-100 px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center font-semibold h-full">
                    %
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {#if tipoContrattoSelected.text !== "COCOCO"}
          <div class="card shadow-lg mt-4 rounded-lg border border-gray-200" class:hidden={!showDipendente}>
            <div class="bg-indigo-50 text-indigo-800 uppercase text-md px-4 py-4 font-semibold flex items-center justify-between">
              <span>Parametri Contributivi</span>
              <!-- svelte-ignore a11y-missing-attribute -->
              <button
                class="text-white py-0.5 px-2 rounded-md shadow-md text-xs font-bold flex items-center gap-1 hover:bg-indigo-500 focus:outline-none bg-indigo-700 "
                on:click={toggleParametriContributivi}
              >
                {showParametriContributivi ? "Nascondi" : "Visualizza"}
              </button>
            </div>

            {#if showParametriContributivi}
              <div class="shadow-lg rounded-lg bg-white p-4">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Aliquota IVS a carico del datore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        name="inpsDipe"
                        id="inpsDipe"
                        min="0"
                        bind:value={$aliquotaIVS}
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span
                        id="inputGroup-sizing-sm"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="tot1" class="block mb-1 text-sm font-medium">
                      IVS a carico del datore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="tot1"
                        name="tot1"
                        disabled
                        value={($importoIVSDatore).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaInail" class="block mb-1 text-sm font-medium">
                      Tasso Inail:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaInail"
                        name="aliquotaInail"
                        bind:value={$aliquotaInail}
                        aria-label="Amount"
                        aria-describedby="inputGroup-sizing-sm"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span
                        id="inputGroup-sizing-sm"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="tot2" class="block mb-1 text-sm font-medium">
                      INAIL:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="tot2"
                        name="tot2"
                        disabled
                        value={($importoInail).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 border-none text-gray-500 focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaIVSDipendente" class="block mb-1 text-sm font-medium">
                      Aliquota IVS a carico del dipendente:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaIVSDipendente"
                        name="aliquotaIVSDipendente"
                        bind:value={$aliquotaIVSDipendente}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span
                        id="inputGroup-sizing-aliquotaIVSDipendente"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-l border-r border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoIVSDipendente" class="block mb-1 text-sm font-medium">
                      IVS a carico del dipendente:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoIVSDipendente"
                        name="importoIVSDipendente"
                        disabled
                        value={($importoIVSDipendente).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaIntegrazione" class="block mb-1 text-sm font-medium">
                      Aliquota Integrazione Datore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaIntegrazione"
                        name="aliquotaIntegrazione"
                        bind:value={$aliquotaIntegrazione}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span
                        id="inputGroup-sizing-aliquotaIntegrazione"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoIntegrazione" class="block mb-1 text-sm font-medium">
                      Importo Integrazione Datore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoIntegrazione"
                        name="importoIntegrazione"
                        disabled
                        value={($importoIntegrazione).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaIntegrazioneLavoratore" class="block mb-1 text-sm font-medium">
                      Aliquota Integrazione Lavoratore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaIntegrazioneLavoratore"
                        name="aliquotaIntegrazioneLavoratore"
                        bind:value={$aliquotaIntegrazioneLavoratore}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoIntegrazioneLavoratore" class="block mb-1 text-sm font-medium">
                      Importo Integrazione Lavoratore:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoIntegrazioneLavoratore"
                        name="importoIntegrazioneLavoratore"
                        disabled
                        value={($importoIntegrazioneLavoratore).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaNaspi" class="block mb-1 text-sm font-medium">
                      Aliquota NASPI:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaNaspi"
                        name="aliquotaNaspi"
                        bind:value={$aliquotaNaspi}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoNaspi" class="block mb-1 text-sm font-medium">
                      Importo NASPI:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoNaspi"
                        name="importoNaspi"
                        disabled
                        value={($importoNaspi).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaContrMalattia" class="block mb-1 text-sm font-medium">
                      Aliquota Contributo malattia:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaContrMalattia"
                        name="aliquotaContrMalattia"
                        bind:value={$aliquotaContrMalattia}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="contributoMalattia" class="block mb-1 text-sm font-medium">
                      Contributo Malattia:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="contributoMalattia"
                        name="contributoMalattia"
                        disabled
                        value={($contributoMalattia).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaContrMaternita" class="block mb-1 text-sm font-medium">
                      Aliquota Contributo Maternità:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaContrMaternita"
                        name="aliquotaContrMaternita"
                        bind:value={$aliquotaContrMaternita}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoContrMaternita" class="block mb-1 text-sm font-medium">
                      Contributo Maternità:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoContrMaternita"
                        name="importoContrMaternita"
                        disabled
                        value={($importoContrMaternita).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaCUAF" class="block mb-1 text-sm font-medium">
                      Aliquota CUAF:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaCUAF"
                        name="aliquotaCUAF"
                        bind:value={$aliquotaCUAF}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoCUAF" class="block mb-1 text-sm font-medium">
                      Contributo CUAF:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoCUAF"
                        name="importoCUAF"
                        disabled
                        value={($importoCUAF).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaFondoGaranziaTfr" class="block mb-1 text-sm font-medium">
                      Aliquota Fondo Garanzia TFR:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaFondoGaranziaTfr"
                        name="aliquotaFondoGaranziaTfr"
                        bind:value={$aliquotaFondoGaranziaTfr}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoFondoGaranziaTfr" class="block mb-1 text-sm font-medium">
                      Fondo Garanzia TFR:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoFondoGaranziaTfr"
                        name="importoFondoGaranziaTfr"
                        disabled
                        value={($importoFondoGaranziaTfr).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="aliquotaFormazione" class="block mb-1 text-sm font-medium">
                      Aliquota Formazione:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="aliquotaFormazione"
                        name="aliquotaFormazione"
                        bind:value={$aliquotaFormazione}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoFormazione" class="block mb-1 text-sm font-medium">
                      Importo Formazione:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoFormazione"
                        name="importoFormazione"
                        disabled
                        value={($importoFormazione).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div>

                  <!-- <div class="col-span-1 flex flex-col justify-end">
                    <label for="esonero080" class="block mb-1 text-sm font-medium">
                      Esonero 0,80%:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0 text-sm">
                      <input
                        type="number"
                        min="0"
                        id="esonero080"
                        name="esonero080"
                        bind:value={$esonero080}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      />
                      <span 
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold">
                        %
                      </span>
                    </div>
                  </div> -->

                  <!-- <div class="col-span-1 flex flex-col justify-end">
                    <label for="importoEsonero080" class="block mb-1 text-sm font-medium">
                      Importo Esonero 0,80%:<small></small>
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0 text-sm">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        id="importoEsonero080"
                        name="importoEsonero080"
                        disabled
                        value={($importoEsonero080).toFixed(2)}
                        aria-label="Amount"
                        class="flex-grow min-w-0 w-full px-3 py-1 bg-gray-100 text-gray-500 border-none cursor-not-allowed focus:outline-none"
                      />
                    </div>
                  </div> -->
                </div>

                <div class="border-t pt-4 text-right space-y-2">
                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale Aliquota INPS:</div>
                      <div class="col-span-1 text-right font-bold">
                        {($totaleAliquotaInps).toFixed(2)} %
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale INPS Lavoratore:</div>
                      <div class="col-span-1 text-right font-bold">
                        {money.format(($totaleInpsLavoratoreDip).toFixed(2))}
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale INPS:</div>
                      <div class="col-span-1 text-right font-bold">
                        {money.format($totaleInps)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {/if}
          </div>
        {:else}
          <div class="card shadow-lg mt-4 rounded-lg border border-gray-200 " class:d-none={showDipendente}>
            <div class="bg-indigo-50 text-indigo-800 uppercase text-md px-4 py-4 font-semibold flex items-center justify-between">
              <span>Parametri Contributivi Lavoro Parasubordinato</span>
              <button
                class="text-white py-0.5 px-2 rounded-md shadow-md text-xs font-bold flex items-center gap-1 hover:bg-indigo-500 focus:outline-none bg-indigo-700 "
                on:click={toggleParametriContributivi}
              >
                {showParametriContributivi ? "Nascondi" : "Visualizza"}
              </button>
            </div>

            {#if showParametriContributivi}
              <div class="card-body bg-white p-4">

                <!-- Prima riga -->
                <div class="grid grid-cols-3 gap-4 mt-4">
                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Aliquota IVS:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        name="inpsDipe"
                        id="inpsDipe"
                        min="0"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        bind:value={$aliquotaIvsParasub}
                      />
                      <span
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      IVS a carico del committente:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoIvsParasubCommittente).toFixed(2)}
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      IVS a carico del lavoratore:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoIvsParasubLavoratore).toFixed(2)}
                      />
                    </div>
                  </div>
                </div>

                <!-- Seconda riga -->
                <div class="grid grid-cols-3 gap-4 mt-4">
                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="mb-1 block text-sm font-medium">
                      Aliquota Malattia Maternita ANF:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        name="inpsDipe"
                        id="inpsDipe"
                        min="0"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        bind:value={$aliquotaMalattiaMaternitaAnfParasub}
                      />
                      <span
                        id="inputGroup-sizing-sm"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Importo Malattia Maternita ANF Committente:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoMalattiaMaternitaAnfParasubComm).toFixed(2)}
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="mb-1 block text-sm font-medium">
                      Importo Malattia Maternita ANF Lavoratore:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoMalattiaMaternitaAnfParasubLav).toFixed(2)}
                      />
                    </div>
                  </div>
                </div>

                <!-- Terza riga -->
                <div class="grid grid-cols-3 gap-4 mt-4">
                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Aliquota DIS-COLL:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        name="inpsDipe"
                        id="inpsDipe"
                        min="0"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        bind:value={$aliquotaDisCollParasub}
                      />
                      <span
                        id="inputGroup-sizing-sm"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Importo DIS-COLL Committente:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoDisCollParasubComm).toFixed(2)}
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                      Importo DIS-COLL Lavoratore:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoDisCollParasubLav).toFixed(2)}
                      />
                    </div>
                  </div>
                </div>

                <!-- Quarta riga -->
                <div class="grid grid-cols-3 gap-4 my-4">
                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="mb-1 block text-sm font-medium">
                      Tasso INAIL:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded min-w-0">
                      <input
                        type="number"
                        min="0"
                        name="inpsDipe"
                        id="inpsDipe"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm rounded-l border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        bind:value={$aliquotaInailParasub}
                      />
                      <span
                        id="inputGroup-sizing-sm"
                        class="bg-gray-100 h-full px-2 text-sm text-gray-600 rounded-r border-l border-gray-300 flex items-center justify-center select-none font-semibold"
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="mb-1 block text-sm font-medium">
                      Importo INAIL Committente:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoInailParasubComm).toFixed(2)}
                      />
                    </div>
                  </div>

                  <div class="col-span-1 flex flex-col justify-end">
                    <label for="inpsDipe" class="mb-1 block text-sm font-medium">
                      Importo INAIL Lavoratore:
                    </label>
                    <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                      <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                      <input
                        type="number"
                        class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                        aria-label="Amount"
                        id="tot"
                        name="tot"
                        disabled
                        value={($importoInailParasubLav).toFixed(2)}
                      />
                    </div>
                  </div>
                </div>

                <!-- Totali -->
                <div class="border-t pt-4 text-right space-y-2">
                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale Aliquota INPS:</div>
                      <div class="col-span-1 text-right font-bold">
                        {$totaleAliquotaInpsParasub.toFixed(2)}%
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale INPS Committente:</div>
                      <div class="col-span-1 text-right font-bold">
                        {money.format($totaleInpsParasubComm)}
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale INPS Lavoratore:</div>
                      <div class="col-span-1 text-right font-bold">
                        {money.format($totaleInpsParasubLav)}
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-5 w-full">
                    <div class="col-span-2"></div>
                    <div class="col-span-3 grid grid-cols-3">
                      <div class="col-span-2 text-right">Totale INPS:</div>
                      <div class="col-span-1 text-right font-bold">
                        {money.format($totaleInpsParasub)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            {/if}
          </div>
        {/if}
        
        <div class="shadow-lg mt-4 rounded-lg border border-gray-200">
          <div class="bg-indigo-50 text-indigo-800 uppercase text-md px-4 py-4 font-semibold flex items-center justify-between">
            <span>Parametri Fiscali</span>
            <button
              class="text-white py-0.5 px-2 rounded-md shadow-md text-xs font-bold flex items-center gap-1 hover:bg-indigo-500 focus:outline-none bg-indigo-700 "
              on:click={toggleParametriFiscali}
            >
              {showParametriFiscali ? "Nascondi" : "Visualizza"}
            </button>
          </div>
          {#if showParametriFiscali}
            <div class="bg-white p-4 rounded-lg">
              <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
                <!-- TODO: Da aggiornare -->
                <div class="col-span-1 flex flex-col justify-end">
                  <label for="inpsDipe" class="block mb-1 text-sm font-medium"
                    >Addizionale IRPEF Regionale:<small></small>
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="tot"
                      name="tot"
                      disabled
                      value={($irpefRegionale).toFixed(2)}
                    />
                  </div>
                </div>

                <!-- TODO: Da aggiornare -->
                <div class="col-span-1 flex flex-col justify-end">
                  <label for="inpsDipe" class="block mb-1 text-sm font-medium">
                    Addizionale IRPEF Comunale:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 border-none text-gray-500 border-none focus:outline-none focus:ring-0"
                      aria-label="Amount"
                      id="tot"
                      name="tot"
                      disabled
                      value={($importoIrpefComunale).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    Detrazione per lavoro dipendente e assimilato:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($detrazioniPerRedditiLavoro).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end"> 
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    Detrazione coniuge:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($detrazioniConiugi).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    Detrazione per figli maggiori di 21 anni:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($detrazioniFigliSopra21).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    Detrazione Altri Familiari:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($detrazioniAltriFamiliari).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    Trattamento Integrativo:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      min="0"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm text-sm border-none focus:outline-none focus:ring-1 focus:ring-indigo-500"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      bind:value={$trattamentoIntegrativo}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    IRPEF Lorda:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($irpefLorda).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="lordo" class="block mb-1 text-sm font-medium">
                    IRPEF Netta:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($irpefNetta).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="sommaC4" class="block mb-1 text-sm font-medium">
                    Somma C.4 Art. 1 L.206/24:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="sommac4"
                      name="sommac4"
                      disabled
                      value={($sommac4l206).toFixed(2)}
                    />
                  </div>
                </div>

                <div class="col-span-1 flex flex-col justify-end">
                  <label for="ulterioreDetrazione" class="block mb-1 text-sm font-medium">
                    Ulteriore Detrazione C.6 Art. 1 L.207/24:
                  </label>
                  <div class="flex items-center border border-gray-300 rounded-md min-w-0">
                    <span class="bg-gray-100 h-full px-2 text-sm text-gray-600 flex items-center justify-center select-none font-semibold">€</span>
                    <input
                      type="number"
                      class="flex-grow min-w-0 w-full px-3 py-1 text-sm bg-gray-100 text-gray-500 border-none focus:outline-none cursor-not-allowed"
                      aria-label="Amount"
                      id="lordo"
                      name="lordo"
                      disabled
                      value={($ulterioreDetrazioneC6).toFixed(2)}
                    />
                  </div>
                </div>

              </div>
            </div>
          {/if}
        </div>
  
        
        <div class="mt-8">
          <div class="w-full">
            <h4 class="text-xl font-semibold mb-3 text-indigo-800">SIMULAZIONE DI COSTO MENSILE</h4>
            <div class="overflow-x-auto bg-white rounded-xl shadow-md">
              <table class="min-w-full text-sm text-left border-collapse">
                <thead class="bg-gray-100">
                  <tr>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Netto Lavoratore</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Imposte</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Contributi</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Rateo Mensile TFR</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Costo Mensile Totale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-gray-50">
                    <td id="simCostoMensile.nettoMedio" class="border border-gray-200 px-3 py-3">
                      {money.format($nettoDipendenteMensile)}
                    </td>
                    <td id="simCostoMensile.lordo" class="border border-gray-200 px-3 py-3">
                      {money.format($imposteMensili)}
                    </td>
                    <td id="simCostoMensile.f24" class="border border-gray-200 px-3 py-3">
                      {money.format($contibutMese)}
                    </td>
                    <td id="simCostoMensile.costoAzienda" class="border border-gray-200 px-3 py-3">
                      {money.format($rateoTfrMensile)}
                    </td>
                    <td id="simCostoMensile.costoAzienda" class="border border-gray-200 px-3 py-3">
                      {money.format($costoMensile)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <div class="w-full">
            <h4 class="text-lg font-semibold mb-3 text-indigo-800">SIMULAZIONE DI COSTO ANNUA</h4>
            <div class="overflow-x-auto bg-white rounded-xl shadow-md">
              <table class="min-w-full text-sm text-left border-collapse">
                <thead class="bg-gray-100">
                  <tr>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Netto Lavoratore</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Imposte</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Contributi</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Rateo Annuale TFR</th>
                    <th scope="col" class="border border-gray-200 px-3 py-4 font-semibold">Costo Annuale Totale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-gray-50">
                    <td id="simCostoMensile.nettoMedio" class="border border-gray-200 px-3 py-3">
                      {money.format($nettoDipendente)}
                    </td>
                    <td id="simCostoMensile.lordo" class="border border-gray-200 px-3 py-3">
                      {money.format($imposteAnnuali)}
                    </td>
                    <td id="simCostoMensile.f24" class="border border-gray-200 px-3 py-3">
                      {money.format($contibutiAnno)}
                    </td>
                    <td id="simCostoMensile.costoAzienda" class="border border-gray-200 px-3 py-3">
                      {money.format($rateoTfrAnnuale)}
                    </td>
                    <td id="simCostoMensile.costoAzienda" class="border border-gray-200 px-3 py-3">
                      {money.format($costoAnnuale)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- Modal -->
  {#if showStampaModal}
    <StampaModal bind:visible={showStampaModal}
      data={{
        startDate: $startDate,
        endDate: $endDate,
        ral: $ral,
        nettoDipendenteMensile: $nettoDipendenteMensile,
        costoMensile: $costoMensile,
        costoAnnuale: $costoAnnuale,
        nettoDipendente: $nettoDipendente,
        numeroMensilita: $numeroMensilita,
      }}
    />
  {/if}
</main>

<style>
  @media (min-width: 640px) {
    .custom-grid {
      grid-template-columns: 25% 75%;
    }
  }
</style>
